module.exports = __webpack_public_path__ + "images/skip.png?a212a8826cf3655a7c4a4e6c7a27a8bb";


//////////////////
// WEBPACK FOOTER
// ./static/images/skip.png
// module id = 82
// module chunks = 0